import { BtnPrimary } from '../ui/components';
import { state } from '../store';
import { t } from '../i18n';
import { sanitizeHtml } from '../utils/sanitize';
import { startRematch, endTournament } from '../engine/TournamentEngine';

declare global {
  interface Window {
    trnRematch: () => void;
    trnGoHome: () => void;
  }
}

window.trnRematch = () => {
  startRematch();
  window.navTo('tournament-board');
};

window.trnGoHome = () => {
  endTournament();
  window.navTo('home');
};

export function renderTournamentVictory(): string {
  const tr = state.tournament;
  if (!tr || !tr.winnerTeamId) {
    setTimeout(() => window.navTo('home'), 0);
    return '';
  }
  const winner = tr.teams.find(t => t.id === tr.winnerTeamId);
  if (!winner) {
    setTimeout(() => window.navTo('home'), 0);
    return '';
  }

  const punishment = tr.settings.punishment.trim();

  return `
    <div class="absolute inset-0 overflow-y-auto overflow-x-hidden bg-void z-20 flex flex-col" id="screen-tournament-victory">
      <div class="flex-1 flex flex-col items-center justify-center px-[24px] py-[40px] text-center">
        <div class="text-[96px] animate-[iconFloat_3s_ease-in-out_infinite] mb-[16px]">🏆</div>
        <div class="font-display text-[32px] font-extrabold bg-grad-premium bg-clip-text text-transparent mb-[8px]">${t('trn_victory_title')}</div>

        <div class="mt-[12px] p-[20px_24px] bg-glass border border-neon-gold/40 rounded-lg shadow-glow-gold w-full max-w-[320px]">
          <div class="text-[64px] mb-[8px]">${winner.emoji}</div>
          <div class="font-display text-[22px] font-extrabold text-white">${sanitizeHtml(winner.name)}</div>
          <div class="text-[13px] text-t-secondary font-semibold mt-[2px]">${t('trn_victory_team_won').replace('{team}', '')}</div>
        </div>

        <div class="mt-[24px] w-full max-w-[320px] p-[16px_18px] bg-[linear-gradient(135deg,rgba(255,45,107,0.08),rgba(160,32,240,0.05))] border border-neon-pink/25 rounded-md text-left">
          <div class="text-[11px] font-extrabold tracking-[1.5px] text-neon-pink mb-[6px]">${t('trn_victory_punishment_label')}</div>
          <div class="text-[14px] text-white font-semibold leading-[1.5] max-h-[120px] overflow-y-auto">
            ${punishment ? sanitizeHtml(punishment) : `<span class="text-t-muted italic">${t('trn_victory_no_punishment')}</span>`}
          </div>
        </div>
      </div>

      <div class="p-[20px_16px] flex flex-col gap-[10px]">
        ${BtnPrimary({ text: t('trn_victory_rematch'), onClick: 'trn-rematch' })}
        <button class="w-full py-[15px] px-[24px] bg-glass border border-b-glass rounded-pill text-white font-body text-[16px] font-bold backdrop-blur-[12px] active:scale-[0.97] transition" data-action="trn-go-home">
          ${t('trn_victory_home')}
        </button>
      </div>
    </div>
  `;
}
